// extracted by mini-css-extract-plugin
export default {"container":"home-product_container__woqil","products":"home-product_products__oIMBj","content":"home-product_content__87EW6"};